import moment from "moment/moment";
import { getOrdinalSuffix } from "./getOrdinalSuffix";

export const getNextPaymentDate = (billingMode, date) => {
  const day = moment(date).format("D");
  const dayWithSuffix = `${day}${getOrdinalSuffix(parseInt(day))}`;
  if (billingMode === "monthly") {
    return `${dayWithSuffix} day of every month`;
  }
  return moment(date).format("MM/DD/YYYY");
};
